import clsx from "clsx";
import { X } from "lucide-react";

interface CloseButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
  size?: "sm" | "md";
}
export function CloseButton({
  onClick,
  label = "Close",
  className,
  size = "md",
}: CloseButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={clsx(
        "cursor-pointer text-theme-text-placeholder transition-all duration-200 ease-in-out",
        "hover:text-theme-danger hover:scale-110 hover:rotate-90 active:scale-95",
        className
      )}
    >
      <X className={size === "sm" ? "h-4 w-4" : "h-6 w-6"} />
    </button>
  );
}

export default CloseButton;
